import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/renderprops-addons.cjs'

// Components
import Layout from '../components/Layout'
import ProjectCard from '../components/ProjectCard'

// Elements
import Inner from '../elements/Inner'
import { Title, BigTitle, Subtitle } from '../elements/Titles'

// Views
import Hero from '../views/Hero'
import Projects from '../views/Projects'
import About from '../views/About'
import Contact from '../views/Contact'

import logo from '../images/logo_transparent.png'

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`

const Logo = styled.img`
  ${tw`squared-full w-32 xl:w-48 h-auto`};
`

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`

const AboutDesc = styled.span`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`

const ContactText = styled.p`
  ${tw`text-grey-light font-sans text-xl md:text-2xl lg:text-3xl`};
`

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 font-sans text-md lg:text-lg`};
`

const year = new Date().getFullYear();

// const FooterLine = styled.div`
//   ${tw.}
// `

const Index = () => (
  <>
    <Layout />
    <Parallax pages={5} >
      <Hero offset={0}>
        <BigTitle>
          Bizware, <br /> software developement agency.
        </BigTitle>
        <Subtitle>Next generation software tailored just for you</Subtitle>
      </Hero>
      <Projects offset={1}>
        <Title>What can we help with</Title>
        <ProjectsWrapper>
          
          <ProjectCard
            title="Monetize your platform"
            // link=""
            bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)"
          >
            Payment Service Provider Integrations
          </ProjectCard>

          <ProjectCard
            title="Add User Management"            
            bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
          >
            Add Authentication and authorization
          </ProjectCard>

          <ProjectCard
            title="Move your platform to the Cloud"
            bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)"
          >
            Cloud based web apps
          </ProjectCard>

          <ProjectCard
            title="Monitor your business with advanced HMI"
            bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)"
          >
            Industry 4.0
          </ProjectCard>


        </ProjectsWrapper>
      </Projects>
      <About offset={3}>
        <Title>About</Title>
        <AboutHero>
          <Logo src={logo} alt="Bizware logo" />
          <AboutSub>
            Bizware is a software development company with a focus on new technologies and agile approach on development and delivery.
            <br />
            <AboutDesc>
              Developing and delivering Cloud, Web and Native applications
              Bizware, vl.Krešimir Marić <br />
              Josipa Kozarca 2, 31220 Višnjvac <br />
              IBAN: HR6123600001102711956 <br />
            </AboutDesc>
          </AboutSub>
        </AboutHero>
      </About>
      <Contact offset={4}>
        <Inner>
          <Title>Get in touch</Title>
          <ContactText>
            Say <a href="mailto:kmaric@bizware.io">Hi</a> on kmaric@bizware.io
            {/* find me on other platforms:{' '} */}
            {/* <a href="https://bizware-workspace.slack.com/messages/CJWDGG667" target="_blank">Slack</a> */}
          </ContactText>
        </Inner>
        <Footer>
          &copy; {year}  by Bizware{' '}
        </Footer>
      </Contact>
    </Parallax>
  </>
)

export default Index
